import { IconProps, iconA11yProps } from '../types';

export const PlannedDurationIcon = ({ classNames, label }: IconProps) => (
    <svg className={`${classNames}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...iconA11yProps(label)}>
        <path d="M17.5 6L12 7.5L6.5 6" />
        <path d="M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z" />
        <path d="M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z" />
    </svg>
);
